import type { CoBrandDetailsState } from './types';

export const coBrandDetailsInitial: CoBrandDetailsState = {
  subDomain: ''
};
